@if (show) {
  <table style="width: 100%">
    <thead>
      <tr>
        <th style="width: 5%">
          <ngx-skeleton-loader count="1" appearance="line" [theme]="{ height: '25px', margin: '5px' }" />
        </th>
        <th style="width: auto">
          <ngx-skeleton-loader count="1" appearance="line" [theme]="{ height: '25px', margin: '5px' }" />
        </th>
      </tr>
    </thead>
    <tbody>
      @for (each of loaderItems(30); track each) {
        <tr>
          <td style="width: 5%">
            <ngx-skeleton-loader count="1" appearance="circle" [theme]="{ height: '25px', width: '25px', margin: '5px' }" />
          </td>
          <td style="width: auto">
            <ngx-skeleton-loader count="1" appearance="line" [theme]="{ height: '25px', margin: '5px' }" />
          </td>
        </tr>
      }
    </tbody>
  </table>
}
